export function isProductionEnvironment(): boolean {
  // Define the non-production URLs
  const nonProductionHosts = [
    "localhost",
    "homologacao.customersys.tech",
    "inhousehomologacao.com",
  ];

  return !nonProductionHosts.includes(window.location.hostname);
}
